import { environment } from '@environments/environment';
import { getProductTypeLabel, ProductTypeKey } from '@shared/services/elastic-search/mappings';

export const GET_PACKS_QUERY = (langcode: string, pack_type: ProductTypeKey, filters?: string[]) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_packs ?? '',
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          {
            term: {
              pack_type: getProductTypeLabel(pack_type),
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          ...(filters && filters?.length > 0 ? [{ terms: { filters } }] : []),
        ],
      },
    },
    sort: [
      {
        field_weight: {
          order: 'asc',
        },
      },
    ],
  },
});
